import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { resetPassword } from "../../API/adminDetails";
import "./resetPassword.css";
import { Button } from "@mui/material";

const ResetPassword = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState<string[]>([]);
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError([]);
        setSuccess("");

        if (!password || !confirmPassword) {
            setError(["Please fill in all fields."]);
            return;
        }

        if (password !== confirmPassword) {
            setError(["Passwords do not match!"]);
            return;
        }

        if (password.length < 6) {
            setError(["Password must be at least 6 characters long."]);
            return;
        }


        try {
            setLoading(true);
            await resetPassword(token as string, password);
            setSuccess("Password updated successfully! Redirecting to login...");
            setTimeout(() => navigate("/login"), 2000);
        } catch (err: any) {
            const message = err.response?.data?.message;

            if (Array.isArray(message)) {
                setError(
                    message.map((err: any) =>
                        Object.values(err.constraints).join(", ")
                    )
                );
            } else {
                setError([message || "Something went wrong!"]);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="reset-password-container">
            <div className="reset-password-card">
                <h2 className="reset-password-title">Reset Password</h2>
                <form onSubmit={handleSubmit} className="reset-password-form">
                    <input
                        type="password"
                        placeholder="New Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="reset-password-input"
                    />
                    <input
                        type="password"
                        placeholder="Confirm New Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        className="reset-password-input"
                    />

                    {error.length > 0 && (
                        <div className="reset-password-message error">
                            {error.map((errMsg, index) => (
                                <p key={index}>{errMsg}</p>
                            ))}
                        </div>
                    )}

                    <Button
                        type="submit"
                        disabled={loading}
                    >
                        {loading ? "Updating..." : "Reset Password"}
                    </Button>

                </form>
            </div>
        </div>
    );
};

export default ResetPassword;
